import axios from './api';

const API_URL = '/users/';

const createUser = async (userData) => {
  const response = await axios.post(API_URL, userData);
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

const getAllUsers = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

const deleteUser = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const updateUser = async (id, data) => {
  const response = await axios.patch(API_URL + id, data);
  return response.data;
};

const UserService = {
  createUser,
  getById,
  getAllUsers,
  deleteUser,
  updateUser,
};

export default UserService;
